import styled, { css } from 'styled-components'
import { minmedia, maxmedia } from './media-queries'
import { bordergray, white, whitegray, brightred, red, black, inputgray, darkgray } from './colors'

// CONTENTS:
// Container, FlexContainer, Block, BlockHeader,
// PopupContainer, Popup, PopupHeader, PopupTitle, CloseButton, Number
// Label, Input, Button

export const Container = styled.div`
  position: relative;
  max-width: 92%;
  width: 1600px;
  height: ${props => props.height};
  margin-left: auto;
  margin-right: auto;

  ${props =>
    props.small &&
    css`
      width: 1300px;
    `};

  ${props =>
    props.full &&
    css`
      ${maxmedia.large`
      max-width: 100%;
    `};
    `} ${props =>
      props.mobileFull &&
      css`
        ${maxmedia.medium`
      max-width: 100%;
    `};
      `} ${props =>
      props.mt &&
      css`
        margin-top: 1.5rem;
        ${minmedia.medium`
      margin-top: 2rem;
    `} ${minmedia.large`
      margin-top: 3rem;
    `};
      `} ${props =>
      props.mb &&
      css`
        margin-bottom: 1.5rem;
        ${minmedia.medium`
      margin-bottom: 2rem;
    `} ${minmedia.large`
      margin-bottom: 3rem;
    `};
      `} ${props =>
      props.mg3 &&
      css`
        margin-top: 0;
        margin-bottom: 0;
        ${minmedia.medium`
      margin-top: 2rem;
    `} ${minmedia.large`
      margin-top: 3rem;
      margin-bottom: 3rem;
    `};
      `};

  ${props =>
    props.relative &&
    css`
      position: relative;
    `};
`

export const FlexContainer = Container.extend`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${props =>
    props.ac &&
    css`
      align-items: center;
    `};
`

export const Block = styled.div`
  position: relative;
  width: 100%;
  display: block;
  margin-bottom: 1rem;
  background: ${white};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;

  ${props =>
    props.two &&
    css`
      ${minmedia.medium`
      width: calc(50% - .25rem);
    `};
    `} ${props =>
      props.three &&
      css`
        ${minmedia.medium`
      width: calc(50% - 1rem);
      margin-bottom: 1.5rem;

      &:last-child {
        width: 100%;
      }
    `} ${minmedia.xmlarge`
      width: calc(100%/3 - 1rem);
      margin-bottom: 0;

      &:last-child {
        width: calc(100%/3 - 1rem);
      }
    `};
      `} a {
    text-decoration: none;
  }
`

export const BlockHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid ${bordergray};

  h1,
  h2,
  h3 {
    margin-bottom: 0;
    line-height: 1;
    font-size: 18px;
    font-weight: 400;
  }

  ${minmedia.medium`
    padding: 1rem 1.5rem;

    h1, h2, h3 {
      font-size: 20px;
    }
  `} ${minmedia.large`
    padding: 1.5rem 2rem;

    h1, h2, h3 {
      font-size: 26px;
    }
  `};
`

export const PopupContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 11;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const Popup = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 90%;
  width: ${props => (props.width ? props.width : '550px')};
  border-radius: 0.25rem;
  overflow: hidden;
  background: ${white};
  border: 1px solid ${bordergray};
  box-shadow: 0px 1px 8px 3px rgba(0, 0, 0, 0.2);
`

export const PopupHeader = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid ${bordergray};
  padding: 1rem;

  ${minmedia.medium`
    padding: 1rem 1.5rem;
  `};
`

export const PopupTitle = styled.h3`
  margin: 0;
  font-weight: 300;
`

export const CloseButton = styled.div`
  margin-top: 0.5rem;
  cursor: pointer;

  &:hover {
    svg {
      fill: ${red};
    }
  }
  svg {
    width: 1.2rem;
    height: 1.2rem;
    transition: all 0.2s;
    fill: ${black};
  }
`

export const Number = styled.div`
  position: absolute;
  top: calc(50% - 1.6rem);
  right: -0.8rem;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: ${brightred};
  color: ${white};
  font-size: 10px;
`

export const Label = styled.input`
  display: block;
  margin-bottom: 0.5rem;
  color: ${darkgray};
`

export const Input = styled.input`
  transition: all 0.5s;
  padding: 0.75rem 1rem;
  font-weight: 300;
  font-size: 18px;
  background: ${whitegray};
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  color: ${black};
  display: inline-block;
  width: 100%;

  ${minmedia.medium`
    font-size: 18px;
  `} &:focus {
    border-color: ${inputgray};
    box-shadow: 0px 0px 5px 0px ${inputgray};
    outline: none;
  }

  &::-webkit-input-placeholder {
    color: ${inputgray};
  }
  &::-moz-placeholder {
    color: ${inputgray};
    opacity: 1;
  }
  &:-ms-input-placeholder {
    color: ${inputgray};
  }
`

export const Button = styled.button`
  transition: all 0.5s;
  background: ${red}
  color: ${white};
  border-radius: 0.25rem;
  font-size: 18px;
  font-weight: 300;
  padding: 0.75rem 1.5rem;
  display: inline-block;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  font-family: 'Montserrat', sans-serif;
  &:focus {
    outline: none;
  }
  &:hover {
    background: ${black};
  }
`

export const DefaultButton = styled.div`
  transition: all 0.5s;
  background: ${red}
  color: ${white};
  border-radius: 0.25rem;
  font-size: 18px;
  font-weight: 300;
  padding: 0.75rem 1.5rem;
  display: inline-block;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-family: 'Montserrat', sans-serif;
  &:focus {
    outline: none;
  }
  &:hover {
    background: ${black};
  }
`



// WEBPACK FOOTER //
// ./src/styles/defaults.js